const fields = document.querySelectorAll(".input-container, .textarea-container");

// Loop through all nodes of `fields`
fields?.forEach(field => {
    // Select the input field and label
    const input = field.querySelector("input, textarea");
    const label = field.querySelector("label");

    // Add an eventlistener to the input field
    input.addEventListener("input", (e) => {
        const value = e.target.value; // Get the current value
        if (value) {
            // Shrink the label if the field has a value
            label.classList.add("shrinked");
        } else {
            // Scale the label if the field has a value
            label.classList.remove("shrinked");
        }
    });
});